import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import withInit from 'WithInit';
import * as PDFPageEditorOptInPanelActions from 'PDFUtils/PDFUtilsActions';
import PDFPageEditorOptInPanelWrapper from './PDFPageEditorOptInPanelWrapper';

const mapStateToProps = ({ PDFPageEditorOptInPanelReducer }) => (
  {
    pages: PDFPageEditorOptInPanelReducer.pages,
  }
);

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    ...PDFPageEditorOptInPanelActions,
  }, dispatch)
);

const PDFPageEditorOptInPanelWithRedux = ReactRedux.connect(
  mapStateToProps,
  mapDispatchToProps,
)(PDFPageEditorOptInPanelWrapper);

export default withInit(PDFPageEditorOptInPanelWithRedux, true);



// WEBPACK FOOTER //
// ./src-react/PDFPageEditorOptInPanel/index.jsx